import { atom } from "recoil";

const titleSoundAtom = atom({
  key: "titleSoundState",
  default: "",
});

export default titleSoundAtom;
